import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_ancillaries';
export const route = 'ancillaries/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "flights_ancillaries_page" */
/* webpackPrefetch: true */
'../components/AncillariesPage')));